
/* injects from baggage-loader */

angular.module("siter.io").controller("DashboardLessonSections", [
  "$scope", "$rootScope", "$state", "$timeout", "Site", "Modal", "Template", "$location", "Section", "Widget", "Notification", "Lesson",
  ($scope, $rootScope, $state, $timeout, Site, Modal, Template, $location, Section, Widget, Notification, Lesson) => {

    if (window.justclick.currentUser.role === "client") {
      $location.path('/404');
    }

    $rootScope.site = {};

    $scope.state = $state;
    $scope.currentState = $state.current.name;
    $scope.tagobject = {tagName: ""};
    $scope.scrollDisabled = false;
    $scope.lessons = [];
    $scope.getHomePagePath = (pages) => {
      if (pages.length === 0) {
        return false;
      }

      const homePage = _.filter(pages, {
        home: true
      });

      return homePage[0].path;
    };

    $scope.lessonSectionsLoading = true;

    Section.getLessonSections().then((sections) => {
      $scope.lessonSections = sections.sections;
      $scope.lessonSectionsLoading = false;
    });

    $scope.saveSection = (section) => {
      Section.savePublic(section);
    };

    $scope.removeSection = (section, collection) => {
      const findedSection = _.filter(collection, {id: section.id});
      const index = collection.indexOf(findedSection[0]);

      $rootScope.alertDialog({
        title: "Deleting a section",
        text: "Are you sure you want to delete this section?",
        accept_text: "Yes",
        cancel_text: "Cancel",
        accept: function() {
          Section.removePublic(section.id).then(() => {
            return collection.splice(index, 1);
          });
        }
      });
    };

    $scope.editSectionModal = Modal.editSectionModal;
    $scope.newLessonSectionModal = Modal.newLessonSectionModal;
  }
]);



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboardLessonSections.controller.js